/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTestIndexRouteImport } from './routes/_authenticated/test/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedStudyTextIndexRouteImport } from './routes/_authenticated/study-text/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedQuestionLibIndexRouteImport } from './routes/_authenticated/question-lib/index'
import { Route as AuthenticatedModulesIndexRouteImport } from './routes/_authenticated/modules/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedClassIndexRouteImport } from './routes/_authenticated/class/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedUsersStudentIdRouteImport } from './routes/_authenticated/users/$studentId'
import { Route as AuthenticatedTestModuleIdRouteImport } from './routes/_authenticated/test/$moduleId'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedQuestionLibQuesiontionLibIdRouteImport } from './routes/_authenticated/question-lib/$quesiontionLibId'
import { Route as AuthenticatedCreatePracticeTestModuleIdRouteImport } from './routes/_authenticated/create-practice-test/$moduleId'
import { Route as AuthenticatedCreateMockExamModuleIdRouteImport } from './routes/_authenticated/create-mock-exam/$moduleId'
import { Route as AuthenticatedQuestionLibQuestionLibIdQuestionIdRouteImport } from './routes/_authenticated/question-lib/$questionLibId.$questionId'
import { Route as AuthenticatedModulesDetailModuleIdRouteImport } from './routes/_authenticated/modules/detail.$moduleId'
import { Route as AuthenticatedClassClassIdModuleIdRouteImport } from './routes/_authenticated/class/$classId.$moduleId'
import { Route as AuthenticatedMarkingListParticipantPtIdClassIdRouteImport } from './routes/_authenticated/marking/list-participant.$ptId.$classId'
import { Route as AuthenticatedCreatePracticeTestDetailPtIdModuleIdRouteImport } from './routes/_authenticated/create-practice-test/detail.$ptId.$moduleId'
import { Route as AuthenticatedCreateMockExamDetailPtIdModuleIdRouteImport } from './routes/_authenticated/create-mock-exam/detail.$ptId.$moduleId'

const ClerkRouteImport = createFileRoute('/clerk')()

const ClerkRoute = ClerkRouteImport.update({
  id: '/clerk',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => ClerkRoute,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/clerk/(auth)',
  path: '/clerk/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTestIndexRoute = AuthenticatedTestIndexRouteImport.update({
  id: '/test/',
  path: '/test/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedStudyTextIndexRoute =
  AuthenticatedStudyTextIndexRouteImport.update({
    id: '/study-text/',
    path: '/study-text/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedQuestionLibIndexRoute =
  AuthenticatedQuestionLibIndexRouteImport.update({
    id: '/question-lib/',
    path: '/question-lib/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedModulesIndexRoute =
  AuthenticatedModulesIndexRouteImport.update({
    id: '/modules/',
    path: '/modules/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClassIndexRoute = AuthenticatedClassIndexRouteImport.update({
  id: '/class/',
  path: '/class/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedUsersStudentIdRoute =
  AuthenticatedUsersStudentIdRouteImport.update({
    id: '/users/$studentId',
    path: '/users/$studentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTestModuleIdRoute =
  AuthenticatedTestModuleIdRouteImport.update({
    id: '/test/$moduleId',
    path: '/test/$moduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedQuestionLibQuesiontionLibIdRoute =
  AuthenticatedQuestionLibQuesiontionLibIdRouteImport.update({
    id: '/question-lib/$quesiontionLibId',
    path: '/question-lib/$quesiontionLibId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreatePracticeTestModuleIdRoute =
  AuthenticatedCreatePracticeTestModuleIdRouteImport.update({
    id: '/create-practice-test/$moduleId',
    path: '/create-practice-test/$moduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreateMockExamModuleIdRoute =
  AuthenticatedCreateMockExamModuleIdRouteImport.update({
    id: '/create-mock-exam/$moduleId',
    path: '/create-mock-exam/$moduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQuestionLibQuestionLibIdQuestionIdRoute =
  AuthenticatedQuestionLibQuestionLibIdQuestionIdRouteImport.update({
    id: '/question-lib/$questionLibId/$questionId',
    path: '/question-lib/$questionLibId/$questionId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedModulesDetailModuleIdRoute =
  AuthenticatedModulesDetailModuleIdRouteImport.update({
    id: '/modules/detail/$moduleId',
    path: '/modules/detail/$moduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClassClassIdModuleIdRoute =
  AuthenticatedClassClassIdModuleIdRouteImport.update({
    id: '/class/$classId/$moduleId',
    path: '/class/$classId/$moduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMarkingListParticipantPtIdClassIdRoute =
  AuthenticatedMarkingListParticipantPtIdClassIdRouteImport.update({
    id: '/marking/list-participant/$ptId/$classId',
    path: '/marking/list-participant/$ptId/$classId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreatePracticeTestDetailPtIdModuleIdRoute =
  AuthenticatedCreatePracticeTestDetailPtIdModuleIdRouteImport.update({
    id: '/create-practice-test/detail/$ptId/$moduleId',
    path: '/create-practice-test/detail/$ptId/$moduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreateMockExamDetailPtIdModuleIdRoute =
  AuthenticatedCreateMockExamDetailPtIdModuleIdRouteImport.update({
    id: '/create-mock-exam/detail/$ptId/$moduleId',
    path: '/create-mock-exam/detail/$ptId/$moduleId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk': typeof ClerkAuthenticatedRouteRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/create-mock-exam/$moduleId': typeof AuthenticatedCreateMockExamModuleIdRoute
  '/create-practice-test/$moduleId': typeof AuthenticatedCreatePracticeTestModuleIdRoute
  '/question-lib/$quesiontionLibId': typeof AuthenticatedQuestionLibQuesiontionLibIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/test/$moduleId': typeof AuthenticatedTestModuleIdRoute
  '/users/$studentId': typeof AuthenticatedUsersStudentIdRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/class': typeof AuthenticatedClassIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/modules': typeof AuthenticatedModulesIndexRoute
  '/question-lib': typeof AuthenticatedQuestionLibIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/study-text': typeof AuthenticatedStudyTextIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/test': typeof AuthenticatedTestIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/class/$classId/$moduleId': typeof AuthenticatedClassClassIdModuleIdRoute
  '/modules/detail/$moduleId': typeof AuthenticatedModulesDetailModuleIdRoute
  '/question-lib/$questionLibId/$questionId': typeof AuthenticatedQuestionLibQuestionLibIdQuestionIdRoute
  '/create-mock-exam/detail/$ptId/$moduleId': typeof AuthenticatedCreateMockExamDetailPtIdModuleIdRoute
  '/create-practice-test/detail/$ptId/$moduleId': typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdRoute
  '/marking/list-participant/$ptId/$classId': typeof AuthenticatedMarkingListParticipantPtIdClassIdRoute
}
export interface FileRoutesByTo {
  '/clerk': typeof ClerkAuthenticatedRouteRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/create-mock-exam/$moduleId': typeof AuthenticatedCreateMockExamModuleIdRoute
  '/create-practice-test/$moduleId': typeof AuthenticatedCreatePracticeTestModuleIdRoute
  '/question-lib/$quesiontionLibId': typeof AuthenticatedQuestionLibQuesiontionLibIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/test/$moduleId': typeof AuthenticatedTestModuleIdRoute
  '/users/$studentId': typeof AuthenticatedUsersStudentIdRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/class': typeof AuthenticatedClassIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/modules': typeof AuthenticatedModulesIndexRoute
  '/question-lib': typeof AuthenticatedQuestionLibIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/study-text': typeof AuthenticatedStudyTextIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/test': typeof AuthenticatedTestIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/class/$classId/$moduleId': typeof AuthenticatedClassClassIdModuleIdRoute
  '/modules/detail/$moduleId': typeof AuthenticatedModulesDetailModuleIdRoute
  '/question-lib/$questionLibId/$questionId': typeof AuthenticatedQuestionLibQuestionLibIdQuestionIdRoute
  '/create-mock-exam/detail/$ptId/$moduleId': typeof AuthenticatedCreateMockExamDetailPtIdModuleIdRoute
  '/create-practice-test/detail/$ptId/$moduleId': typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdRoute
  '/marking/list-participant/$ptId/$classId': typeof AuthenticatedMarkingListParticipantPtIdClassIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk': typeof ClerkRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/create-mock-exam/$moduleId': typeof AuthenticatedCreateMockExamModuleIdRoute
  '/_authenticated/create-practice-test/$moduleId': typeof AuthenticatedCreatePracticeTestModuleIdRoute
  '/_authenticated/question-lib/$quesiontionLibId': typeof AuthenticatedQuestionLibQuesiontionLibIdRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/test/$moduleId': typeof AuthenticatedTestModuleIdRoute
  '/_authenticated/users/$studentId': typeof AuthenticatedUsersStudentIdRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/class/': typeof AuthenticatedClassIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/modules/': typeof AuthenticatedModulesIndexRoute
  '/_authenticated/question-lib/': typeof AuthenticatedQuestionLibIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/study-text/': typeof AuthenticatedStudyTextIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/test/': typeof AuthenticatedTestIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/class/$classId/$moduleId': typeof AuthenticatedClassClassIdModuleIdRoute
  '/_authenticated/modules/detail/$moduleId': typeof AuthenticatedModulesDetailModuleIdRoute
  '/_authenticated/question-lib/$questionLibId/$questionId': typeof AuthenticatedQuestionLibQuestionLibIdQuestionIdRoute
  '/_authenticated/create-mock-exam/detail/$ptId/$moduleId': typeof AuthenticatedCreateMockExamDetailPtIdModuleIdRoute
  '/_authenticated/create-practice-test/detail/$ptId/$moduleId': typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdRoute
  '/_authenticated/marking/list-participant/$ptId/$classId': typeof AuthenticatedMarkingListParticipantPtIdClassIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/settings'
    | '/clerk'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/create-mock-exam/$moduleId'
    | '/create-practice-test/$moduleId'
    | '/question-lib/$quesiontionLibId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/test/$moduleId'
    | '/users/$studentId'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/chats'
    | '/class'
    | '/help-center'
    | '/modules'
    | '/question-lib'
    | '/settings/'
    | '/study-text'
    | '/tasks'
    | '/test'
    | '/users'
    | '/class/$classId/$moduleId'
    | '/modules/detail/$moduleId'
    | '/question-lib/$questionLibId/$questionId'
    | '/create-mock-exam/detail/$ptId/$moduleId'
    | '/create-practice-test/detail/$ptId/$moduleId'
    | '/marking/list-participant/$ptId/$classId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clerk'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/create-mock-exam/$moduleId'
    | '/create-practice-test/$moduleId'
    | '/question-lib/$quesiontionLibId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/test/$moduleId'
    | '/users/$studentId'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/chats'
    | '/class'
    | '/help-center'
    | '/modules'
    | '/question-lib'
    | '/settings'
    | '/study-text'
    | '/tasks'
    | '/test'
    | '/users'
    | '/class/$classId/$moduleId'
    | '/modules/detail/$moduleId'
    | '/question-lib/$questionLibId/$questionId'
    | '/create-mock-exam/detail/$ptId/$moduleId'
    | '/create-practice-test/detail/$ptId/$moduleId'
    | '/marking/list-participant/$ptId/$classId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/settings'
    | '/clerk/(auth)'
    | '/clerk'
    | '/clerk/_authenticated'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/create-mock-exam/$moduleId'
    | '/_authenticated/create-practice-test/$moduleId'
    | '/_authenticated/question-lib/$quesiontionLibId'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/test/$moduleId'
    | '/_authenticated/users/$studentId'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/_authenticated/chats/'
    | '/_authenticated/class/'
    | '/_authenticated/help-center/'
    | '/_authenticated/modules/'
    | '/_authenticated/question-lib/'
    | '/_authenticated/settings/'
    | '/_authenticated/study-text/'
    | '/_authenticated/tasks/'
    | '/_authenticated/test/'
    | '/_authenticated/users/'
    | '/_authenticated/class/$classId/$moduleId'
    | '/_authenticated/modules/detail/$moduleId'
    | '/_authenticated/question-lib/$questionLibId/$questionId'
    | '/_authenticated/create-mock-exam/detail/$ptId/$moduleId'
    | '/_authenticated/create-practice-test/detail/$ptId/$moduleId'
    | '/_authenticated/marking/list-participant/$ptId/$classId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkRoute: typeof ClerkRouteWithChildren
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/clerk': {
      id: '/clerk'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof ClerkRoute
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/test/': {
      id: '/_authenticated/test/'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof AuthenticatedTestIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/study-text/': {
      id: '/_authenticated/study-text/'
      path: '/study-text'
      fullPath: '/study-text'
      preLoaderRoute: typeof AuthenticatedStudyTextIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/question-lib/': {
      id: '/_authenticated/question-lib/'
      path: '/question-lib'
      fullPath: '/question-lib'
      preLoaderRoute: typeof AuthenticatedQuestionLibIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/modules/': {
      id: '/_authenticated/modules/'
      path: '/modules'
      fullPath: '/modules'
      preLoaderRoute: typeof AuthenticatedModulesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/class/': {
      id: '/_authenticated/class/'
      path: '/class'
      fullPath: '/class'
      preLoaderRoute: typeof AuthenticatedClassIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/users/$studentId': {
      id: '/_authenticated/users/$studentId'
      path: '/users/$studentId'
      fullPath: '/users/$studentId'
      preLoaderRoute: typeof AuthenticatedUsersStudentIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/test/$moduleId': {
      id: '/_authenticated/test/$moduleId'
      path: '/test/$moduleId'
      fullPath: '/test/$moduleId'
      preLoaderRoute: typeof AuthenticatedTestModuleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/question-lib/$quesiontionLibId': {
      id: '/_authenticated/question-lib/$quesiontionLibId'
      path: '/question-lib/$quesiontionLibId'
      fullPath: '/question-lib/$quesiontionLibId'
      preLoaderRoute: typeof AuthenticatedQuestionLibQuesiontionLibIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-practice-test/$moduleId': {
      id: '/_authenticated/create-practice-test/$moduleId'
      path: '/create-practice-test/$moduleId'
      fullPath: '/create-practice-test/$moduleId'
      preLoaderRoute: typeof AuthenticatedCreatePracticeTestModuleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-mock-exam/$moduleId': {
      id: '/_authenticated/create-mock-exam/$moduleId'
      path: '/create-mock-exam/$moduleId'
      fullPath: '/create-mock-exam/$moduleId'
      preLoaderRoute: typeof AuthenticatedCreateMockExamModuleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/question-lib/$questionLibId/$questionId': {
      id: '/_authenticated/question-lib/$questionLibId/$questionId'
      path: '/question-lib/$questionLibId/$questionId'
      fullPath: '/question-lib/$questionLibId/$questionId'
      preLoaderRoute: typeof AuthenticatedQuestionLibQuestionLibIdQuestionIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/modules/detail/$moduleId': {
      id: '/_authenticated/modules/detail/$moduleId'
      path: '/modules/detail/$moduleId'
      fullPath: '/modules/detail/$moduleId'
      preLoaderRoute: typeof AuthenticatedModulesDetailModuleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/class/$classId/$moduleId': {
      id: '/_authenticated/class/$classId/$moduleId'
      path: '/class/$classId/$moduleId'
      fullPath: '/class/$classId/$moduleId'
      preLoaderRoute: typeof AuthenticatedClassClassIdModuleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/marking/list-participant/$ptId/$classId': {
      id: '/_authenticated/marking/list-participant/$ptId/$classId'
      path: '/marking/list-participant/$ptId/$classId'
      fullPath: '/marking/list-participant/$ptId/$classId'
      preLoaderRoute: typeof AuthenticatedMarkingListParticipantPtIdClassIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-practice-test/detail/$ptId/$moduleId': {
      id: '/_authenticated/create-practice-test/detail/$ptId/$moduleId'
      path: '/create-practice-test/detail/$ptId/$moduleId'
      fullPath: '/create-practice-test/detail/$ptId/$moduleId'
      preLoaderRoute: typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/create-mock-exam/detail/$ptId/$moduleId': {
      id: '/_authenticated/create-mock-exam/detail/$ptId/$moduleId'
      path: '/create-mock-exam/detail/$ptId/$moduleId'
      fullPath: '/create-mock-exam/detail/$ptId/$moduleId'
      preLoaderRoute: typeof AuthenticatedCreateMockExamDetailPtIdModuleIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCreateMockExamModuleIdRoute: typeof AuthenticatedCreateMockExamModuleIdRoute
  AuthenticatedCreatePracticeTestModuleIdRoute: typeof AuthenticatedCreatePracticeTestModuleIdRoute
  AuthenticatedQuestionLibQuesiontionLibIdRoute: typeof AuthenticatedQuestionLibQuesiontionLibIdRoute
  AuthenticatedTestModuleIdRoute: typeof AuthenticatedTestModuleIdRoute
  AuthenticatedUsersStudentIdRoute: typeof AuthenticatedUsersStudentIdRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedClassIndexRoute: typeof AuthenticatedClassIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedModulesIndexRoute: typeof AuthenticatedModulesIndexRoute
  AuthenticatedQuestionLibIndexRoute: typeof AuthenticatedQuestionLibIndexRoute
  AuthenticatedStudyTextIndexRoute: typeof AuthenticatedStudyTextIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTestIndexRoute: typeof AuthenticatedTestIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedClassClassIdModuleIdRoute: typeof AuthenticatedClassClassIdModuleIdRoute
  AuthenticatedModulesDetailModuleIdRoute: typeof AuthenticatedModulesDetailModuleIdRoute
  AuthenticatedQuestionLibQuestionLibIdQuestionIdRoute: typeof AuthenticatedQuestionLibQuestionLibIdQuestionIdRoute
  AuthenticatedCreateMockExamDetailPtIdModuleIdRoute: typeof AuthenticatedCreateMockExamDetailPtIdModuleIdRoute
  AuthenticatedCreatePracticeTestDetailPtIdModuleIdRoute: typeof AuthenticatedCreatePracticeTestDetailPtIdModuleIdRoute
  AuthenticatedMarkingListParticipantPtIdClassIdRoute: typeof AuthenticatedMarkingListParticipantPtIdClassIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCreateMockExamModuleIdRoute:
    AuthenticatedCreateMockExamModuleIdRoute,
  AuthenticatedCreatePracticeTestModuleIdRoute:
    AuthenticatedCreatePracticeTestModuleIdRoute,
  AuthenticatedQuestionLibQuesiontionLibIdRoute:
    AuthenticatedQuestionLibQuesiontionLibIdRoute,
  AuthenticatedTestModuleIdRoute: AuthenticatedTestModuleIdRoute,
  AuthenticatedUsersStudentIdRoute: AuthenticatedUsersStudentIdRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedClassIndexRoute: AuthenticatedClassIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedModulesIndexRoute: AuthenticatedModulesIndexRoute,
  AuthenticatedQuestionLibIndexRoute: AuthenticatedQuestionLibIndexRoute,
  AuthenticatedStudyTextIndexRoute: AuthenticatedStudyTextIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTestIndexRoute: AuthenticatedTestIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedClassClassIdModuleIdRoute:
    AuthenticatedClassClassIdModuleIdRoute,
  AuthenticatedModulesDetailModuleIdRoute:
    AuthenticatedModulesDetailModuleIdRoute,
  AuthenticatedQuestionLibQuestionLibIdQuestionIdRoute:
    AuthenticatedQuestionLibQuestionLibIdQuestionIdRoute,
  AuthenticatedCreateMockExamDetailPtIdModuleIdRoute:
    AuthenticatedCreateMockExamDetailPtIdModuleIdRoute,
  AuthenticatedCreatePracticeTestDetailPtIdModuleIdRoute:
    AuthenticatedCreatePracticeTestDetailPtIdModuleIdRoute,
  AuthenticatedMarkingListParticipantPtIdClassIdRoute:
    AuthenticatedMarkingListParticipantPtIdClassIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkRouteChildren {
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRoute
}

const ClerkRouteChildren: ClerkRouteChildren = {
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRoute,
}

const ClerkRouteWithChildren = ClerkRoute._addFileChildren(ClerkRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkRoute: ClerkRouteWithChildren,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
